import React, { useEffect, useState } from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { setProductFieldsJSON } from "../../../../slices/orders/orderSlice";
import rootReducer from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";

const SelectDropdown = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  const dispatch = useDispatch();
  const selectError = useSelector(
    (state) => state.common.formRendererValidation.select
  );
  const productFieldsJSON = useSelector(
    (state) => state.order.ProductFieldsJSON
  );
  const abc = useSelector((state) => state.common.formRendererState);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const detailsFieldJson = useSelector(
    (state) => state.order.selectedOrders.detailsFieldJson
  );

  const dataCustomValue = fieldEle?.["data-customvalue"];
  const datasourcelist = fieldEle?.["data-datasourcelist"];
  const parentAttributeKey = fieldEle?.["parent-attributekey"];
  const parentSelectedValue = formState[parentAttributeKey];
  const key = databaseKey ? databaseKey : displayLabelKey;
  const isRequired = showRequired ? fieldEle?.["display-required"] === 1 : false;
  const selectedOption = options.find(
    (option) => option.value === formState[key] || option.value === "ACTIVE"
  );
  const isInvalid = isRequired && !selectedOption;
  const validationClass = isInvalid ? "is-invalid" : "is-valid";

  useEffect(() => {
    if (!formState[key]) {
      const activeOption = options.find((option) => option.value === "ACTIVE");
      const statusOption = options.find(
        (option) => option.value === "PAYMENT-PENDING"
      );
      const productOption = options.find(
        (option) => option.value === "CLUBBED"
      );
      const freshOption = options.find((option) => option.value === "FRESH");
      if (activeOption) {
        dispatch(setRendererFormState({ key, value: "ACTIVE" }));
      }
      if (statusOption) {
        dispatch(setRendererFormState({ key, value: "PAYMENT-PENDING" }));
      }
      if (freshOption) {
        dispatch(setRendererFormState({ key, value: "FRESH" }));
      }
      if (productOption) {
        dispatch(setRendererFormState({ key, value: "CLUBBED" }));
      }
    }
  }, [dispatch, formState, key, options]);

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        if (datasourcelist) {
          // const response = await getAllDropdownListItems(
          //   datasourcelist,
          //   productFieldsJSON,
          //   "PPET",
          //   abc.product_id,
          //   "QUL",
          //   parentSelectedValue
          // );
          if (response) {
            const data = response;
            if (Array.isArray(data)) {
              const updatedOptions = data.map((item) => ({
                value: item.value || item.key,
                label: item.label || item.value || item.key,
              }));
              setOptions(updatedOptions);
              const updatedProductFieldsJSON = {
                ...productFieldsJSON,
                [datasourcelist]: {
                  ...productFieldsJSON[datasourcelist],
                  "data-customvalue": updatedOptions,
                },
              };
              dispatch(setProductFieldsJSON(updatedProductFieldsJSON));
            } else {
              console.warn("Unexpected data format received:", data);
            }
          } else {
            console.error(
              "API Response is undefined or missing data property:",
              response
            );
          }
        } else {
          let optArray = [];
          if (typeof dataCustomValue === "string") {
            optArray = dataCustomValue.split("#");
          } else if (Array.isArray(dataCustomValue)) {
            optArray = dataCustomValue;
          }
          const updatedOptions = optArray.map((opt) => ({
            value: opt.value || opt.key || opt,
            label: opt.label || opt.value || opt.key || opt,
          }));
          setOptions(updatedOptions);
        }
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [detailsFieldJson, parentSelectedValue, dispatch, fieldEle]);

  const selectedValue = formState[key] || "ACTIVE";

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className={`form-group ${validationClass}`}
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <Select
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          name={key}
          options={options}
          placeholder={fieldEle?.["display-placeholder"]}
          isDisabled={fieldEle?.["display-disabled"] === 1}
          isRequired={isRequired}
          value={
            options.find((option) => option.value === selectedValue) || null
          }
          onChange={(e) => {
            rootReducer.dispatch(setRendererFormState({ key, value: e.value }));
          }}
          className={validationClass}
        />
        {selectError && (
          <div className="invalid-feedback">This field is required</div>
        )}
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default SelectDropdown;
